export default "__VITE_ASSET__CDtdTgys__"